export default __webpack_public_path__ + "static/Image-black-a9235acdcad9bb23d305904d0376cb2f.png";